import React from 'react';
import { DocPageLayout } from '../components/DocPageLayout';
export function AnnouncementsPage() {
  const announcements = [{
    date: 'February 15, 2026',
    title: 'API Version 73 Now Available',
    type: 'New Feature',
    typeColor: 'bg-green-100 text-green-700',
    description: 'API version 73 introduces enhanced 3D Secure 2.2 support, improved tokenization APIs, and new webhook event types. We recommend upgrading to take advantage of the latest features and security improvements.'
  }, {
    date: 'January 28, 2026',
    title: 'Apple Pay Web Support Enhanced',
    type: 'Update',
    typeColor: 'bg-blue-100 text-blue-700',
    description: 'Apple Pay on the web now supports recurring payments and merchant-initiated transactions. Updated JavaScript library available with new configuration options for subscription billing.'
  }, {
    date: 'January 10, 2026',
    title: 'New Fraud Detection Rules Engine',
    type: 'New Feature',
    typeColor: 'bg-green-100 text-green-700',
    description: 'A completely redesigned fraud rules engine is now available in the Merchant Administration portal. Create complex rule chains with AND/OR logic, velocity checks, and machine learning-assisted risk scoring.'
  }, {
    date: 'December 5, 2025',
    title: 'API Version 70 Deprecation Notice',
    type: 'Deprecation',
    typeColor: 'bg-red-100 text-red-700',
    description: 'API version 70 and below will be deprecated on June 30, 2026. Please migrate to version 72 or later before this date. Requests to deprecated versions will return HTTP 410 Gone after the deprecation date.'
  }, {
    date: 'November 20, 2025',
    title: 'Batch Processing Performance Improvements',
    type: 'Update',
    typeColor: 'bg-blue-100 text-blue-700',
    description: 'Batch file processing throughput has been increased by 3x. Large batch files (500+ operations) now complete significantly faster. No changes to the API are required.'
  }, {
    date: 'October 8, 2025',
    title: 'Google Pay Integration Guide Updated',
    type: 'Update',
    typeColor: 'bg-blue-100 text-blue-700',
    description: 'The Google Pay integration documentation has been updated with new code examples for the latest Google Pay API version. Includes support for shipping address collection and promo codes.'
  }];
  return <DocPageLayout title="Announcements" description="Stay up to date with the latest changes, new features, and important notices about the payment gateway." data-id="element-304">
      <div className="space-y-0" data-id="element-305">
        {announcements.map((item, index) => <div key={index} className={`py-8 ${index !== announcements.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-306">
            <div className="flex items-center gap-3 mb-3" data-id="element-307">
              <span className="text-sm text-gray-500" data-id="element-308">{item.date}</span>
              <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${item.typeColor}`} data-id="element-309">
                {item.type}
              </span>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-310">
              {item.title}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-311">
              {item.description}
            </p>
          </div>)}
      </div>
    </DocPageLayout>;
}